module.exports = __webpack_public_path__ + "static/media/delete.142b16e5.svg";